import { motion } from "framer-motion";
import ProductCard from "@/components/product/ProductCard";
import { ProductGridSkeleton } from "@/components/product/ProductCardSkeleton";
import { useProducts } from "@/hooks/useProducts";
import { useLanguage } from "@/context/LanguageContext";

const FeaturedProducts = () => {
  const { data: products = [], isLoading } = useProducts();
  const { t } = useLanguage();

  return (
    <section id="best-sellers" className="section-padding bg-background">
      <div className="container-luxury">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-primary text-sm tracking-[0.3em] uppercase">
            {t.featured.badge}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif mt-4 mb-6">
            {t.featured.title}
          </h2>
          <div className="divider-gold w-32 mx-auto" />
          <p className="text-muted-foreground mt-6 max-w-xl mx-auto">
            {t.featured.description}
          </p>
        </motion.div>

        {isLoading && <ProductGridSkeleton count={3} />}

        {!isLoading && products.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {(() => {
              const bestSellers = products.filter(p => p.isBestSeller);
              const display = bestSellers.length > 0 ? bestSellers.slice(0, 6) : products.slice(0, 6);
              return display.map((product, index) => (
                <ProductCard key={product.id} product={product} index={index} />
              ));
            })()}
          </div>
        )}

        {!isLoading && products.length === 0 && (
          <div className="text-center py-20">
            <p className="text-muted-foreground">{t.featured.noProducts}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedProducts;
